import dayjs from 'dayjs';

/**
 * 格式化工具
 * 日期、金额、状态文本等格式化函数
 */

/** 格式化日期时间：YYYY-MM-DD HH:mm:ss */
export function formatDateTime(date: string | Date | null | undefined): string {
  if (!date) return '-';
  return dayjs(date).format('YYYY-MM-DD HH:mm:ss');
}

/** 格式化日期：YYYY-MM-DD */
export function formatDate(date: string | Date | null | undefined): string {
  if (!date) return '-';
  return dayjs(date).format('YYYY-MM-DD');
}

/** 格式化金额：保留2位小数，加千分位 */
export function formatMoney(amount: number | string | null | undefined): string {
  if (amount === null || amount === undefined || amount === '') return '0.00';
  const num = Number(amount);
  if (isNaN(num)) return '0.00';
  return num.toLocaleString('zh-CN', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}

/** 格式化金额（带¥符号） */
export function formatCurrency(amount: number | string | null | undefined): string {
  return `¥${formatMoney(amount)}`;
}

/** 审核状态文本 */
export function formatAuditStatus(status: string): string {
  const map: Record<string, string> = {
    pending: '待审核',
    approved: '已通过',
    rejected: '已驳回',
  };
  return map[status] || status;
}

/** 卡类型文本 */
export function formatCardType(type: string): string {
  const map: Record<string, string> = {
    tuotu: '拓拓卡',
    talktiko: 'TalkTiko',
    esim: 'eSIM卡',
  };
  return map[type] || type;
}

/** 卡状态文本 */
export function formatCardStatus(status: string): string {
  const map: Record<string, string> = {
    unbound: '未绑定',
    bound: '已绑定',
  };
  return map[status] || status;
}

/** 用户状态文本 */
export function formatUserStatus(status: string): string {
  const map: Record<string, string> = {
    active: '正常',
    disabled: '已停用',
  };
  return map[status] || status;
}

/** 角色文本 */
export function formatRole(role: string): string {
  const map: Record<string, string> = {
    admin: '管理员',
    agent: '代理',
  };
  return map[role] || role;
}

/** 分账规则类型文本 */
export function formatRuleType(type: string): string {
  const map: Record<string, string> = {
    percentage: '比例',
    fixed: '固定金额',
  };
  return map[type] || type;
}

/** 代理等级文本（1=一级最高，3=三级最低） */
export function formatAgentLevel(level: number | null | undefined): string {
  if (level === null || level === undefined) return '三级代理';
  const map: Record<number, string> = {
    1: '一级代理',
    2: '二级代理',
    3: '三级代理',
  };
  return map[level] || `未知等级(${level})`;
}

/** 操作类型文本 */
export function formatOperationType(type: string): string {
  const map: Record<string, string> = {
    create: '创建',
    update: '修改',
    audit: '审核',
    import: '导入',
    confirm: '确认',
    bind: '绑定',
    transfer: '转移',
    disable: '停用',
    enable: '启用',
  };
  return map[type] || type;
}
